import React from 'react';
import './Toys.css';
import { Link } from 'react-router-dom';
import Data, { TToy } from '../../Data/data';
import Toy from '../../Components/toy/toy';
import Filter from '../../Components/filter/filter';
import { AppContext } from '../../Context/app-state';
import { ESort } from '../../Context/app-type';

const Toys = () => {
  const { filters, sorts } = React.useContext(AppContext);
  const {
    maxCopiesCount,
    minCopiesCount,
    minCopiesYear,
    maxCopiesYear,
    size,
    shape,
    color,
    favorite,
    search,
  } = filters;
  let callBack;

  if (sorts === ESort.nameAlphaDown)
    callBack = (a: TToy, b: TToy) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    };
  if (sorts === ESort.nameAlphaUp)
    callBack = (a: TToy, b: TToy) => {
      if (a.name < b.name) return 1;
      if (a.name > b.name) return -1;
      return 0;
    };
  if (sorts === ESort.yearDateDecrease)
    callBack = (a: TToy, b: TToy) => +a.year - +b.year;
  if (sorts === ESort.yearDateIncrease)
    callBack = (a: TToy, b: TToy) => +b.year - +a.year;

  const dataFilters = Data.filter((el) => {
    return +el.count >= minCopiesCount && +el.count <= maxCopiesCount;
  })
    .filter((el) => {
      return +el.year >= minCopiesYear && +el.year <= maxCopiesYear;
    })
    .filter((el) => {
      const { small, big, average } = size;
      return (
        (!small && !big && !average) ||
        (big && el.size === 'big') ||
        (average && el.size === 'average') ||
        (small && el.size === 'small')
      );
    })
    .filter((el) => {
      const { ball, bell, cone, snowflake, toy } = shape;
      return (
        (!ball && !bell && !cone && !snowflake && !toy) ||
        (ball && el.shape === 'ball') ||
        (bell && el.shape === 'bell') ||
        (cone && el.shape === 'cone') ||
        (snowflake && el.shape === 'snowflake') ||
        (toy && el.shape === 'toy')
      );
    })
    .filter((el) => {
      const { white, yellow, red, blue, green } = color;
      return (
        (!white && !yellow && !red && !blue && !green) ||
        (white && el.color === 'white') ||
        (yellow && el.color === 'yellow') ||
        (red && el.color === 'red') ||
        (blue && el.color === 'blue') ||
        (green && el.color === 'green')
      );
    })
    .filter((el) => {
      if (favorite !== false) {
        return el.favorite === favorite;
      }
      return el;
    })
    .filter((el) => {
      const loweredName = el.name.toLowerCase();
      return loweredName.includes(search.toLowerCase());
    })
    .sort(callBack);
  return (
    <div
      className="App-toys"
      style={{
        backgroundImage: `url(./assets/bg.jpg)`,
      }}
    >
      <div className="App-toys__blur">
        <Filter />
        <div className="App-toys__cards">
          {dataFilters.length <= 0 && (
            <h1 className="App-toys__error">
              Извините, совпадений не обнаружено. Попробуйте еще раз:)
            </h1>
          )}
          {dataFilters.map((toy) => {
            return <Toy key={toy.num} options={toy} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Toys;
